import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Carousel, { ResponsiveType } from 'react-multi-carousel';

import React from 'react';
import { useSelector } from 'react-redux';
import { GalleryComment } from '../../common/models/galleryComment';
import { AppState, galleryCommentSelector } from '../../common/store/store';
import { ReviewBox } from './ReviewBox';

const shuffle = <T,>(arr: T[]): T[] => {
    const a: any[] = [...arr];
    const b: any[] = [];
    while (a.length) {
        b.push(a.splice(Math.floor(Math.random() * a.length), 1)[0]);
    }
    return b;
};

const sendConversionTest = (comment: GalleryComment) => {

    console.log('dataLayer', (window as any).dataLayer);

    (window as any).dataLayer.push({
        'event': 'test',
        'conversionValue': 1,
        'transaction_id': 'review_number_' + comment.id
    });
    console.log('dataLayer', (window as any).dataLayer);
};

const GalleryItem = (props: { commentId: ModelId; }) => {
    const comment = useSelector((state: AppState) => galleryCommentSelector.selectById(state, props.commentId));
    if (!comment) return null;
    return <ReviewBox
        onClick={() => sendConversionTest(comment)}
        sx={{ width: 200, height: 150 }}
        review={comment} />;
};

export const UserReviewGallery = () => {


    const comments = useSelector((state: AppState) => galleryCommentSelector.selectAll(state));


    const responsive: ResponsiveType = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 6,
            slidesToSlide: 2
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 5,
            slidesToSlide: 2,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 1,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1,

        }
    };

    const [orderedContent, sertOrderedContent] = React.useState<ModelId[]>([]);

    React.useEffect(() => {
        const arr: ModelId[] = comments.map(p => p.id);
        sertOrderedContent(shuffle(arr));
    }, []);

    return <Container sx={{ paddingY: 3 }}>
        <Typography variant='h4' textAlign={'center'} marginBottom={4}>Avis de notre clientèle</Typography>
        <Carousel itemClass='reviewCarouselItem' autoPlay={true} infinite={true} autoPlaySpeed={7000} arrows={false} responsive={responsive}>
            {orderedContent.map(p => <GalleryItem key={p} commentId={p} />)}
        </Carousel>
    </Container>;
};
